import { createSyncAction, IBaseAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';

export default function setDeviceTabIdAction(deviceTabId: string): IBaseAction<any> {
	return createSyncAction(ActionTypes.SET_DEVICE_TAB_ID, deviceTabId);
}
